import { Checkbox, Flex, Text, Alert } from '@servicetitan/anvil2';
import { DisclosureText } from './DisclosureText';
import { useEffect, useState } from 'react';
import {
    ElectronicRecordsDisclosureDrawer,
    GeneralApplicationDisclosuresDrawer,
} from './NoticeDrawers';
import { DisclosureDataStore } from './DisclosureStore';
import {
    useSecondLookIntegration,
    useProviderConfig,
    SetupDataStore,
} from '@servicetitan/financing-workflow-shared';
import { SecondLookCoapplicationDisclosure } from './SecondLookCoapplicationDisclosure';

export const Container = () => {
    const [openedNotice, setOpenedNotice] = useState<
        'ElectronicRecordsDisclosure' | 'GeneralApplicationDisclosure' | null
    >(null);
    const {
        setAgreedToDisclosures,
        setApplicantSignature,
        setCoApplicantSignature,
        resetDisclosureState,
    } = DisclosureDataStore.useStore();
    const {
        mustAgreeToMultipleDisclosures,
        turnsCoapplicationDisclosureText,
        prequalDisclosureAlertText,
        useFinancingPrequalSubmission,
        continueToHardAppAfterSoft,
    } = useProviderConfig();
    const { setupData } = SetupDataStore.useStore();
    const secondLookIntegration = useSecondLookIntegration();

    useEffect(() => {
        resetDisclosureState();
    }, [resetDisclosureState]);

    const showPrequalDisclosureAlert =
        !!prequalDisclosureAlertText &&
        useFinancingPrequalSubmission === true &&
        continueToHardAppAfterSoft === true &&
        !setupData?.hasTransitionedToHardApp;

    const [agreedToGeneralDisclosures, setAgreedToGeneralDisclosures] = useState(false);
    // Only require second-look co-application disclosure when there's actual text to show (waterfall scenarios)
    const requireSecondLookDisclosure =
        secondLookIntegration.isEnabled && !!turnsCoapplicationDisclosureText;
    const [agreedToSecondLookDisclosures, setAgreedToSecondLookDisclosures] = useState(
        !requireSecondLookDisclosure,
    );

    const onGeneralDisclosureChange = (attested: boolean) => {
        setAgreedToGeneralDisclosures(attested);
        setAgreedToDisclosures(attested && agreedToSecondLookDisclosures);
    };

    const onSecondLookDisclosureChange = (attested: boolean) => {
        setAgreedToSecondLookDisclosures(attested);
        setAgreedToDisclosures(attested && agreedToGeneralDisclosures);
    };

    return (
        <Flex direction="column" gap="6">
            {showPrequalDisclosureAlert && (
                <Alert status="info" title={prequalDisclosureAlertText} />
            )}
            <DisclosureText
                onOpenNotice={setOpenedNotice}
                onDisclosureChange={onGeneralDisclosureChange}
                onApplicantSignatureChange={setApplicantSignature}
                onCoApplicantSignatureChange={setCoApplicantSignature}
            />
            {openedNotice === 'ElectronicRecordsDisclosure' ? (
                <ElectronicRecordsDisclosureDrawer onClose={() => setOpenedNotice(null)} />
            ) : openedNotice === 'GeneralApplicationDisclosure' ? (
                <GeneralApplicationDisclosuresDrawer onClose={() => setOpenedNotice(null)} />
            ) : null}
            {!mustAgreeToMultipleDisclosures && (
                <Flex direction="column">
                    <Text>
                        <strong>Disclosure Agreement</strong>
                    </Text>
                    <Checkbox
                        label="I agree to the above disclaimers"
                        onChange={(e, state) => onGeneralDisclosureChange(state?.checked ?? false)}
                    />
                </Flex>
            )}
            {requireSecondLookDisclosure && (
                <SecondLookCoapplicationDisclosure onChange={onSecondLookDisclosureChange} />
            )}
        </Flex>
    );
};
